import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { HelpArticleMeta, HelpSection } from '../models';
import { articleUrl } from '../utils/help.utils';

/**
 * Fetches help articles. They are static files under `assets/help`, served next to the app —
 * not an API resource — so this is the one service in the feature that does not use `apiUrl`.
 */
@Injectable({ providedIn: 'root' })
export class HelpContentService {
  private readonly http = inject(HttpClient);

  getArticle(section: HelpSection, article: HelpArticleMeta): Observable<string> {
    return this.http.get(articleUrl(section, article), { responseType: 'text' });
  }
}
